
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, FileText, Calendar } from "lucide-react";

const MobileJourneySection = ({ onClose }: { onClose: () => void }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between py-3 border-b w-full text-left"
      >
        <div className="flex items-center">
          <FileText className="h-5 w-5 text-grandpal-green mr-3" />
          <h3 className="font-medium text-gray-800 font-lora">Your Journey</h3>
        </div>
        <ChevronDown 
          className={`h-5 w-5 text-grandpal-green transition-transform duration-200 ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
        />
      </button>
      {isOpen && (
        <div className="py-4 pl-4 space-y-3 animate-fade-in">
          <Link
            to="/dashboard?tab=applications"
            className="flex items-center gap-2 py-1.5 text-gray-700 hover:text-grandpal-green transition-colors"
            onClick={onClose}
          >
            <FileText className="h-4 w-4 text-grandpal-green" />
            <span>Application progress</span>
          </Link>
          <Link
            to="/dashboard?tab=visits"
            className="flex items-center gap-2 py-1.5 text-gray-700 hover:text-grandpal-green transition-colors"
            onClick={onClose}
          >
            <Calendar className="h-4 w-4 text-grandpal-green" />
            <span>Book visits</span>
          </Link>
        </div>
      )}
    </div>
  );
};

export default MobileJourneySection;
